import script from "./RecTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecTag.vue?vue&type=script&setup=true&lang=ts"

import "./RecTag.vue?vue&type=style&index=0&id=09e62b0e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09e62b0e"]])

export default __exports__